import LogoCardsTitle from "../Logo-Cards-Title/LogoCardsTitle";
import "./services.css";
import ServicesCard from "./ServicesCard";
import Aos from "aos";
import "aos/dist/aos.css";

const Services = () => {
  return (
    <div className="our_service_container">
      <div>
        <h1
          className="lg:text-5xl md:text-3xl text-2xl font-bold text-center"
          data-aos="fade-up"
          data-aos-duration="1000"
        >
          Our{" "}
          <span className="bg-clip-text text-transparent bg-gradient-to-r from-[#E10B7B] via-[#652D90 ] to-[#1C85C7] animate-bounce">
            Services
          </span>
        </h1>
        <h2 className="text-center text-white pt-4">
          LogoLab Nepal offers top logo design services, creating unique logos
          to elevate your brand
        </h2>
      </div>

      <div className="services_card_wrapper">
        <ServicesCard />
      </div>
    </div>
  );
};

export default Services;
